import { styled, Typography } from "@mui/material";

export const Container = styled(Typography)(({ theme }) => ({
  display: "block",
  lineHeight: 1.2,
}));